/**
 * @description 获取文件的后缀
 * @param: str string 文件名称
 */

export function getFileSuffix(str) {
  return str ? str.slice(str.lastIndexOf(".") + 1) : "";
}
